import React from "react";
import { CircleCheck, Upload } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
export default function Hero() {
  const firstBenefit = "Clases particulares\xA0 personalizadas";
  const benefit1 = "Técnicas de Estudio";
  const benefit2 = "Repaso Escolar\xA0";
  const benefit3 = "Repaso Escolar";
  const benefit4 = "Grupos reducidos";
  const benefit5 = "Seguimiento continuo";
  return <section id="hero" className="bg-background py-20 lg:py-32 overflow-hidden">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="flex flex-col gap-8">
            <div className="space-y-4">
              <h1 className="text-5xl lg:text-7xl font-bold tracking-tighter text-secondary font-serif">
                Impulsa tu <span className="text-primary">Futuro</span> Académico
              </h1>
              <p className="text-lg text-secondary/80 max-w-xl leading-relaxed">
                En CENTRO COSMOS transformamos el aprendizaje en una experiencia dinámica y efectiva. Preparación integral para alcanzar tus metas con los mejores profesionales.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-3 gap-x-6">
              <div data-index={0} className="flex items-center gap-2">
                <CircleCheck className="size-5 text-primary shrink-0" />
                <span className="text-sm font-medium text-secondary/90">{firstBenefit}</span>
              </div>
              <div data-index={1} className="flex items-center gap-2">
                <CircleCheck className="size-5 text-primary shrink-0" />
                <span className="text-sm font-medium text-secondary/90">{benefit1}</span>
              </div>
              <div data-index={2} className="flex items-center gap-2"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-circle-check size-5 text-primary shrink-0" aria-hidden="true" data-ast-id="f:/src/pages/Home/sections/Hero.tsx|sig:89m9rm" data-ast-start="2033" data-ast-end="2089"><circle cx="12" cy="12" r="10"></circle><path d="m9 12 2 2 4-4"></path></svg><span className="text-sm font-medium text-secondary/90" data-ast-id="f:/src/pages/Home/sections/Hero.tsx|sig:dwyru3" data-ast-start="2106" data-ast-end="2179">Horarios Flexibles</span></div>
              <div data-index={3} className="flex items-center gap-2">
                <CircleCheck className="size-5 text-primary shrink-0" />
                <span className="text-sm font-medium text-secondary/90">{benefit3}</span>
              </div>
              <div data-index={4} className="flex items-center gap-2">
                <CircleCheck className="size-5 text-primary shrink-0" />
                <span className="text-sm font-medium text-secondary/90">{benefit4}</span>
              </div>
              <div data-index={5} className="flex items-center gap-2">
                <CircleCheck className="size-5 text-primary shrink-0" />
                <span className="text-sm font-medium text-secondary/90">{benefit5}</span>
              </div>
            </div>
          </div>

          <div className="relative w-full max-w-[800px] mx-auto lg:ml-auto mt-8 lg:mt-0">
            <div className="aspect-[2/1] rounded-lg bg-primary/10 absolute -inset-4 -z-10 rotate-3" />
            
          </div>
        </div>
      </div>
    </section>;
}